<template>
  <el-dialog
    ref="dialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="data_list_dialog"
    width="1200px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @open="handleOpen('dialog')"
  >
    <div class="container-box">
      <!-- 查询条件 -->
      <div
        ref="searchCondition"
        class="search-condition"
      >
        <el-row :gutter="10">
          <el-col style="width:60px;padding-left:10px;">
            <el-button type="text">
              物料名称：
            </el-button>
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="tableList.tableQuery.search.materialsName"
              placeholder="请输入物料名称"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="5">
            <el-button
              type="primary"
              @click="searchData(tableList)"
            >
              查询
            </el-button>
            <el-button
              type="primary"
              @click="selectMaterialFun()"
            >
              选择物料
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <div class="table-wrap table-list-show">
        <custom-table
          :ref="tableList.tableKey"
          :table-key="tableList.tableKey"
          :data-obj="tableList"
          :table-columns="tableList.tableColumns"
          :table-data="tableList.tableData"
          :loading="tableList.tableLoading"
          :search-condition.sync="tableList.tableQuery"
          :table-custom-height="tableHeight"
          :is-paging="isPaging"
          sortable="false"
          is-index-field
          is-select-field
          :data-total="tableList.tableDataTotal"
          :table-contextmenu="tableList.tableContextmenu"
          :multiple-selection.sync="multipleSelection"
          @reloadData="loadTableData(tableList)"
          @selectMaterial="selectMaterialFun"
        />
      </div>
    </div>
  </el-dialog>
</template>
<script>
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 计算表格高度，搜索，获取数据Mixin
import dialogTableCustomMixin from '@/mixin/dialogTableCustomMixin'
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 数据请求
import { listDataPageByConditionApi } from '@/api/inventoryInfo'

export default {
  name: 'InventoryList',
  components: { CustomTable },
  mixins: [dialogDragMixin, dialogTableCustomMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    themeColor: {
      type: String,
      default: ''
    },
    depotId: {
      type: Number,
      default: null
    },
    schemeId: {
      type: Number,
      default: null
    },
    selectedMaterials: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      customerName: '',
      tableList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'material_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            prop: 'select',
            label: '选择该物料',
            method: 'selectMaterial'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          sort: { // 排序对象
            prop: 'bill.source_type', // 排序字段
            order: 'desc' // 排序类型 ascending升序 descending降序
          },
          search: {
            materialsName: '',
            depotId: '',
            schemeId: '',
            forOut: 1
          }
        }
      },
      multipleSelection: [],
      isPaging: true
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this
        _this.multipleSelection = []
        if (_this.schemeId > 0) {
          _this.tableList.initTableColumn = [
            { prop: 'depotName', label: '仓库名称', filterColumn: 'db.depot_name', width: 130 },
            { prop: 'schemeName', label: '方案名称', filterColumn: 'db.scheme_name', width: 200 },
            { prop: 'schemeNo', label: '方案编号', filterColumn: 'db.scheme_no', width: 150 },
            { prop: 'materialsName', label: '物料名称', filterColumn: 'db.materials_name' },
            { prop: 'sourceTypeStr', label: '物料来源', filterColumn: '(case db.source_type when 1 then \'自制\' when 2 then \'中心配送\' else \'\' end)', width: 80 },
            { prop: 'unitName', label: '物料单位', filterColumn: 'db.unit_name', width: 80 },
            // { prop: 'price', label: '单价', filterColumn: 'db.price', width: 80, isBetween: true },
            { prop: 'amount', label: '数量', filterColumn: 'db.amount', width: 100, isBetween: true }
            // { prop: 'total', label: '合计', filterColumn: 'db.total', width: 100, isBetween: true },
          ]
        } else {
          _this.tableList.initTableColumn = [
            { prop: 'depotName', label: '仓库名称', filterColumn: 'db.depot_name', width: 130 },
            { prop: 'materialsName', label: '物料名称', filterColumn: 'db.materials_name' },
            { prop: 'sourceTypeStr', label: '物料来源', filterColumn: '(case db.source_type when 1 then \'自制\' when 2 then \'中心配送\' else \'\' end)', width: 80 },
            { prop: 'unitName', label: '物料单位', filterColumn: 'db.unit_name', width: 80 },
            // { prop: 'price', label: '单价', filterColumn: 'db.price', width: 80, isBetween: true },
            { prop: 'amount', label: '数量', filterColumn: 'db.amount', width: 100, isBetween: true }
            // { prop: 'total', label: '合计', filterColumn: 'db.total', width: 100, isBetween: true },
          ]
        }

        _this.tableList.tableColumns = _this.tableList.initTableColumn
        _this.tableList.tableQuery.search.depotId = _this.depotId
        _this.tableList.tableQuery.search.schemeId = _this.schemeId
        _this.searchData(_this.tableList)
      }
    }
  },
  methods: {
    // 请求数据
    requestData () {
      let _this = this
      _this.tableList.tableLoading = true
      listDataPageByConditionApi({ condition: JSON.stringify(_this.tableList.tableQuery) }).then(response => {
        _this.tableList.tableLoading = false
        let data = response.data.data || []
        _this.handleData(_this.tableList, data)
        _this.tableList.tableDataTotal = response.data.recordsTotal || 0
      }).catch()
    },
    // 关闭弹框
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    },
    // 选择物料
    selectMaterialFun () {
      let _this = this
      if (_this.multipleSelection.length < 1) {
        _this.$message({ message: '请选择物料', type: 'warning' })
        return
      } else {
        _this.$emit('selectedMaterialsFun', _this.multipleSelection)
        _this.modalClose()
      }
    }
  }
}
</script>
<style lang="scss"  scoped>
.table-wrap {
  margin-top: 5px;
}
</style>
